export const fr = {
  resourcesPage: {
    aboutSection: "À propos de votre programme de bénévolat",
    charitySection: "Vos organismes de bienfaisance, votre choix",
    about: {
      title: 'À propos de GreenShield Communautaire',
      description:
        'À GreenShield, la bienveillance est dans notre ADN. En tant qu’entreprise sociale sans but lucratif, nous vivons nos valeurs au quotidien, en combinant la détermination, la passion et le savoir-faire pour faire la différence dans les communautés à travers le pays. Nos programmes de dons et de bénévolat vous aident à soutenir les causes qui vous tiennent le plus à cœur.',
    },
    givingLocal: {
      title: 'Programme Donner à sa communauté',
      description:
        'Les employés et employées redonnent à leur communauté grâce à des dons prélevés sur leurs paies. Votez pour les organismes de bienfaisance qui recevront un financement.',
      nominateButton: 'Proposer un organisme de bienfaisance',
      optIn:
        'Inscrivez-vous en soumettant une demande via greenshieldcares@greenshield.ca',
    },
    nominations: {
      title: 'Nos nominations',
      date: 'Avril 2025',
      emptyState:
        'Les organismes de bienfaisance seront ajoutés une fois les votes reçus',
    },
    benefits: {
      title: 'Vos avantages',
      paidTime: {
        description:
          'Chaque année, vous disposez de <strong>2 deux journées (16 heures)</strong> à consacrer à du bénévolat rémunéré par l’intermédiaire de Ma rémunération globale',
        progress: 'heures de bénévolat',
      },
      volunteerDollars: {
        description:
          "Grâce à notre programme Dollars bénévoles pour la charité, GreenShield Cares offre <strong>20 $ en récompenses de bénévolat</strong> pour chaque heure de temps personnel consacrée au bénévolat auprès d'un organisme de bienfaisance enregistré admissible.",
        progress: 'heures de bénévolat',
      },
    },
    initiatives: {
      title: 'Initiatives phares de GreenShield Communautaire',
      learnMore: 'En savoir plus',
      viewEvents: 'Voir les événements associés',
      womensHealth: {
        title: 'Santé mentale des femmes',
        body1:
          'Les femmes sont plus susceptibles de signaler des niveaux d’anxiété et de dépression plus élevés que les hommes, mais elles ont moins de chances d’obtenir le soutien dont elles ont besoin.',
        body2:
          'Unique en son genre dans le pays, le Programme de santé mentale pour les femmes de GreenShield Cares offre gratuitement aux femmes âgées de 18 ans et plus des consultations virtuelles culturellement adaptées et tenant compte de leurs traumatismes.',
        body3:
          'À ce jour, nous avons investi plus de 4 millions de dollars dans des partenariats communautaires afin de créer et d’élargir l’accès aux services de santé mentale et d’aider plus de 120 000 femmes à bénéficier de soins gratuits et d’un soutien significatif.',
      },
      youthHealth: {
        title: 'Santé mentale des jeunes',
        body1:
          'Les jeunes âgés de 16 à 24 ans présentent des problèmes de santé mentale et de toxicomanie en plus grand nombre que les Canadiens et Canadiennes plus âgés, mais ils continuent de se heurter à des obstacles importants en matière de soins.',
        body2:
          'En 2025, en collaboration avec les principales organisations de santé mentale pour les jeunes, GreenShield lancera une solution complète de santé mentale pour les jeunes, conçue pour supprimer les principaux obstacles auxquels les jeunes sont confrontés en matière de soutien à la santé mentale : parcours de soins de santé, accès équitable et abordabilité',
        body3:
          'Notre nouvelle Initiative de santé mentale pour les jeunes s’appuie sur notre engagement à promouvoir l’équité en matière de santé et à veiller à ce que les jeunes Canadiens et Canadiennes bénéficient d’un soutien opportun et culturellement adapté.',
      },
      essentialMedicines: {
        title: 'Médicaments essentiels',
        body1:
          'William Wilkinson a fondé GreenShield pour aider les Canadiens et Canadiennes qui n’avaient pas les moyens d’acheter les médicaments dont ils avaient besoin, estimant que l’accès aux médicaments essentiels est un droit de la personne fondamental.',
        body2:
          'Nous avons lancé notre Programme de médicaments essentiels en 2023 afin de combler les lacunes pour le million de Canadiens et Canadiennes qui n’ont pas les moyens de se procurer les médicaments dont ils ont besoin. En 2024, nous avons dépassé les frontières de l’Ontario pour implanter notre programme en Nouvelle-Écosse et nous comptons l’étendre à d’autres provinces en 2025.',
        body3:
          'À ce jour, nous avons eu un impact positif sur plus de 90 000 personnes en leur donnant accès à une couverture de 1 000 $ par année pour des médicaments essentiels.',
      },
    },
    resources: {
      title: 'Ressources',
      subtext: "Tirer le meilleur parti du bénévolat d’entreprise",
    },
  },
}
